import { useState } from "react";

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import { IProjectComponentProps } from "../../pages/ProjectsPage/ProjectComponent";
import TechIcon from "../TechIcon";

import "./custom-styles.css";

const ProjectAccordion = ({ project }: IProjectComponentProps) => {
  const [factPage, setFactPage] = useState(0);

  const nextFact = () => {
    setFactPage((factPage + 1) % project.facts.length);
  };

  return (
    <Accordion preExpanded={["description"]}>
      <AccordionItem uuid="description">
        <AccordionItemHeading>
          <AccordionItemButton>Description</AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p style={{ color: "black" }}>{project.description}</p>
        </AccordionItemPanel>
      </AccordionItem>
      <AccordionItem>
        <AccordionItemHeading>
          <AccordionItemButton>Stack</AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <div className="stack-container">
            {project.stack.map((tech, idx) => (
              <TechIcon key={idx} tech={tech} />
            ))}
          </div>
        </AccordionItemPanel>
      </AccordionItem>
      <AccordionItem>
        <AccordionItemHeading>
          <AccordionItemButton>Interesting facts</AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <div className="facts-container">
            <p style={{ color: "black" }} className="fact">
              {project.facts[factPage]}
            </p>
            {project.facts.length > 0 && (
              <div className="next-fact-btn-container">
                <span>
                  {factPage + 1}/{project.facts.length}
                </span>
                <button onClick={nextFact}>Next</button>
              </div>
            )}
          </div>
        </AccordionItemPanel>
      </AccordionItem>
    </Accordion>
  );
};

export default ProjectAccordion;
